import { render, staticRenderFns } from "./CourseExportTicp.vue?vue&type=template&id=00457ada&scoped=true&"
import script from "./CourseExportTicp.vue?vue&type=script&lang=js&"
export * from "./CourseExportTicp.vue?vue&type=script&lang=js&"
import style0 from "./CourseExportTicp.vue?vue&type=style&index=0&id=00457ada&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00457ada",
  null
  
)

export default component.exports